//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class LocaleInfoDisplayItem extends ItemBase {
    DisplayName: string | null = null;     // OBSOLETE - Use only for compatibility
    Name: string | null = null;
    NativeCountryName: string | null = null;
    EnglishCountryName: string | null = null;
    NativeLanguageName: string | null = null;
    EnglishLanguageName: string | null = null;

    constructor(initializer?: Partial<LocaleInfoDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "LocaleInfoDisplayItem";
}
